export const DEMO = {
    mainTitle: 'Demo',
    blocks: [
        {
            title: 'Video Demo',
            content:
                'Check out product demos on Youtube. Video library covers different cases and capabilities.',
            icon: '/img/contactPages/video-demo.svg',
            link: '/youtube',
            linkTarget: "_blank",
            btnText: 'Watch',
        },
        {
            title: 'Request a Demo',
            content:
                'We can learn about your needs and present a 30-minute Kubevious SaaS Demo relevant to your own use case.',
            icon: '/img/contactPages/request-demo.svg',
            link: '/demo-request',
            btnText: 'Request',
        },
        {
            title: 'Self Service Demo',
            content:
                'You can also try Kubevious open-source on your own. No registration required.',
            icon: '/img/contactPages/self-service.svg',
            link: 'https://demo.kubevious.io',
            linkTarget: "_blank",
            btnText: 'Interact',
        },
    ],
}
